<app-nav titulo="Detalles de la cotización" descripcion="Estas son las opciones que dió como resultado la cotización.">
    <div class="quote-details" *ngIf="quote">
        <app-quote-result [quote]="quote"></app-quote-result>
    </div>

    <!-- Deshabilitado temporalmente: los servicios ya se muestran en la grilla de app-quote-result
    <div class="services-section">
        <app-data-printer [categories]="servicesCategories"></app-data-printer>
    </div>
    -->

</app-nav>
